import React, { useEffect, useRef, useState } from "react";
import styles from "./StatusButton.module.css";

const StatusButton = ({ onClick, status, disabled = false, keepResend = false }) => {
  const [hovered, setHovered] = useState(false);
  const [completed, setCompleted] = useState(false);
  const timeoutRef = useRef(null);

  // useEffect(() => {
  //   if(keepResend == false && completed)
  //   {
  //     setHovered(false);
  //     setCompleted(false);
  //     clearTimeout(timeoutRef.current);
  //   }
  // }, [keepResend, completed]);

  const handleMouseEnter = () => {
    if (keepResend === false) {
      return
    }
    setHovered(true);
    timeoutRef.current = setTimeout(() => {
      setCompleted(true); // Change text after 1s
    }, 1000);
  };

  const handleMouseLeave = () => {
    setHovered(false);
    clearTimeout(timeoutRef.current);
  };

  let buttonClass = "";
  let buttonText = "";

  switch (status?.toLowerCase()) {
    case "initiate":
      buttonClass = styles.initiate;
      buttonText = "Initiate";
      break;
    case "na":
      buttonClass = styles.na;
      buttonText = "N/A";
      break;
    default:
      buttonClass = styles.sent;
      buttonText = status;
      break;
  }

  return (
    <button
      className={`${styles.button} ${buttonClass} ${(hovered || completed) ? styles.progress : ''} ${completed ? styles.done : ''}`}
      onClick={() => {
        if (keepResend && completed) {
          onClick();

          setTimeout(() => {
            setHovered(false);
            setCompleted(false);
          }, 5000);
        }
        else if (!keepResend) {
          onClick();
        }
      }}
      disabled={disabled}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      {completed ? "Resend" : buttonText}
    </button>
  );
};

export default StatusButton;
